import { IconExternalLink } from '@iwoca/icons';
import { Button, Spinner } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { TApplication } from 'lendingApi/applications.types';
import styles from './OpenInNewTabButton.module.css';
import { useOpenInNewTab } from './useOpenInNewTab.hook';

type TProps = {
  application: TApplication;
};

export const OpenInNewTabButton = ({ application }: TProps) => {
  const { isLoading, handleOpenNewTabClick } = useOpenInNewTab(application);

  return (
    <Button
      className={styles.newTabButton}
      data-testid="open-in-new-tab-button"
      variant="tertiary"
      size="small"
      onClick={handleOpenNewTabClick}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <IconExternalLink className={styles.newTabIcon} />
          <Trans>Open</Trans>
        </>
      )}
    </Button>
  );
};
